import React, { createContext, useState, useCallback, createRef, useEffect, useImperativeHandle, useContext, useRef } from 'react';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var MessageType;
(function (MessageType) {
  MessageType[MessageType["SyncRequest"] = 0] = "SyncRequest";
  MessageType[MessageType["SyncResponse"] = 1] = "SyncResponse";
  MessageType[MessageType["SetStyles"] = 2] = "SetStyles";
  MessageType[MessageType["UpdateContentHeight"] = 3] = "UpdateContentHeight";
  MessageType[MessageType["TokenizePaymentMethodRequest"] = 4] = "TokenizePaymentMethodRequest";
  MessageType[MessageType["TokenizePaymentMethodResponse"] = 5] = "TokenizePaymentMethodResponse";
  MessageType[MessageType["GenerateTokenizeCardTokenRequest"] = 6] = "GenerateTokenizeCardTokenRequest";
  MessageType[MessageType["GenerateTokenizeCardTokenResponse"] = 7] = "GenerateTokenizeCardTokenResponse";
  MessageType[MessageType["AuthorizePaymentMethodRequest"] = 8] = "AuthorizePaymentMethodRequest";
  MessageType[MessageType["AuthorizePaymentMethodResponse"] = 9] = "AuthorizePaymentMethodResponse";
  MessageType[MessageType["ClearForm"] = 10] = "ClearForm";
  MessageType[MessageType["IsFormValid"] = 11] = "IsFormValid";
  MessageType[MessageType["FailureLog"] = 12] = "FailureLog";
})(MessageType || (MessageType = {}));

var SecureFrame = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    containerStyle = _ref.containerStyle,
    url = _ref.url;
  return url === undefined ? React.createElement("iframe", {
    title: title,
    style: {
      display: 'none'
    },
    ref: ref
  }) : React.createElement("iframe", {
    title: title,
    src: url,
    style: containerStyle,
    ref: ref
  });
});

var PaymentFormStatus;
(function (PaymentFormStatus) {
  PaymentFormStatus[PaymentFormStatus["Initializing"] = 0] = "Initializing";
  PaymentFormStatus[PaymentFormStatus["Loading"] = 1] = "Loading";
  PaymentFormStatus[PaymentFormStatus["Failed"] = 2] = "Failed";
  PaymentFormStatus[PaymentFormStatus["PendingSync"] = 3] = "PendingSync";
  PaymentFormStatus[PaymentFormStatus["Loaded"] = 4] = "Loaded";
})(PaymentFormStatus || (PaymentFormStatus = {}));

var PaymentFormContext = /*#__PURE__*/createContext({
  status: PaymentFormStatus.Initializing
});

var clearForm = function clearForm(iframeWindow, iframeUrl) {
  if (iframeUrl === undefined || iframeWindow === undefined) {
    return;
  }
  var message = {
    messageType: MessageType.ClearForm
  };
  iframeWindow == null || iframeWindow.postMessage(message, iframeUrl);
};
var tokenizePaymentMethod = function tokenizePaymentMethod(serviceCollection, setAsDefault, isAlreadyTokenizing, iframeWindow, iframeUrl) {
  var defaultResult = {
    isSuccessful: false,
    completedTokenizationAttempt: false,
    suggestVerifyInformation: false,
    isRewardsCard: false,
    tokenId: null,
    displayName: null,
    mask: null,
    type: null,
    potentialDuplicate: false
  };
  if (iframeUrl === undefined || iframeWindow === undefined) {
    return function () {
      return new Promise(function (resolve) {
        resolve(defaultResult);
      });
    };
  }
  return function (timeout, callback) {
    if (callback === void 0) {
      callback = function callback(_) {};
    }
    return new Promise(function (resolve) {
      var shouldUpdate = true;
      var onMessage = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
          var data, tokenResult;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(!shouldUpdate || event.origin !== iframeUrl)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.t0 = event.data.messageType;
                _context.next = _context.t0 === MessageType.GenerateTokenizeCardTokenRequest ? 5 : _context.t0 === MessageType.TokenizePaymentMethodResponse ? 10 : 23;
                break;
              case 5:
                if (!(isAlreadyTokenizing === true)) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return");
              case 7:
                isAlreadyTokenizing = true;
                serviceCollection.application.generateTokenizeCardToken(setAsDefault, callback).then(function (token) {
                  if (shouldUpdate && token !== undefined) {
                    var attemptTokenMessage = {
                      messageType: MessageType.GenerateTokenizeCardTokenResponse,
                      token: token
                    };
                    iframeWindow == null || iframeWindow.postMessage(attemptTokenMessage, iframeUrl);
                  }
                })["catch"](function () {
                  if (shouldUpdate) {
                    shouldUpdate = false;
                    window.removeEventListener('message', onMessage);
                    resolve(defaultResult);
                  }
                })["finally"](function () {
                  isAlreadyTokenizing = false;
                });
                return _context.abrupt("break", 23);
              case 10:
                if (!shouldUpdate) {
                  _context.next = 22;
                  break;
                }
                shouldUpdate = false;
                window.removeEventListener('message', onMessage);
                data = event.data;
                if (!(data.completedTokenizationAttempt && data.resultToken !== undefined)) {
                  _context.next = 21;
                  break;
                }
                _context.next = 17;
                return serviceCollection.application.validateTokenizeCardResultToken(data.resultToken);
              case 17:
                tokenResult = _context.sent;
                resolve(tokenResult);
                _context.next = 22;
                break;
              case 21:
                resolve(defaultResult);
              case 22:
                return _context.abrupt("break", 23);
              case 23:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function onMessage(_x) {
          return _ref.apply(this, arguments);
        };
      }();
      window.addEventListener('message', onMessage);
      var message = {
        messageType: MessageType.TokenizePaymentMethodRequest
      };
      iframeWindow.postMessage(message, iframeUrl);
      setTimeout(function () {
        if (shouldUpdate) {
          isAlreadyTokenizing = false;
          shouldUpdate = false;
          window.removeEventListener('message', onMessage);
          resolve(defaultResult);
        }
      }, timeout || 60000);
    });
  };
};

function sendFailureLog(window, windowUrl, error) {
  var failureLogEvent = {
    messageType: MessageType.FailureLog,
    error: error
  };
  window == null || window.postMessage(failureLogEvent, windowUrl);
}

var isApplicableMessage = function isApplicableMessage(event, url, messageType) {
  return event.data.messageType === messageType && event.origin === url;
};
var initializingEffect = function initializingEffect(status, serviceCollection, supportedMethods, selectedSupportedMethod, setUrl, setStatus) {
  if (status !== PaymentFormStatus.Initializing) {
    return;
  }
  var shouldUpdate = true;
  serviceCollection.generateRenderFormUrl(supportedMethods, selectedSupportedMethod).then(function (value) {
    if (shouldUpdate) {
      setStatus(PaymentFormStatus.Loading);
      setUrl(value);
    }
  })["catch"](function () {
    if (shouldUpdate) {
      setStatus(PaymentFormStatus.Failed);
    }
  });
  return function () {
    shouldUpdate = false;
  };
};
var loadingEffect = function loadingEffect(status, iframeRef, setStatus, setIframeWindow) {
  var _iframeRef$current;
  if (status !== PaymentFormStatus.Loading) {
    return;
  }
  var shouldUpdate = true;
  var timeoutInMilliseconds = 30000;
  function onLoad() {
    return _onLoad.apply(this, arguments);
  }
  function _onLoad() {
    _onLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var contentWindow;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (shouldUpdate) {
              contentWindow = this.contentWindow;
              if (contentWindow === null) {
                setStatus(PaymentFormStatus.Failed);
              } else {
                setStatus(PaymentFormStatus.PendingSync);
                setIframeWindow(contentWindow);
              }
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    return _onLoad.apply(this, arguments);
  }
  (_iframeRef$current = iframeRef.current) == null || _iframeRef$current.addEventListener('load', onLoad);
  setTimeout(function () {
    if (shouldUpdate) {
      setStatus(PaymentFormStatus.Failed);
    }
  }, timeoutInMilliseconds);
  return function () {
    var _iframeRef$current2;
    shouldUpdate = false;
    (_iframeRef$current2 = iframeRef.current) == null || _iframeRef$current2.removeEventListener('load', onLoad);
  };
};
var pendingSyncEffect = function pendingSyncEffect(status, iframeWindow, iframeUrl, styles, setStatus) {
  if (status !== PaymentFormStatus.PendingSync || iframeWindow === undefined || iframeUrl === undefined) {
    return;
  }
  var shouldUpdate = true;
  var onMessage = function onMessage(event) {
    if (shouldUpdate && isApplicableMessage(event, iframeUrl, MessageType.SyncResponse)) {
      shouldUpdate = false;
      setStatus(PaymentFormStatus.Loaded);
    }
  };
  window.addEventListener('message', onMessage);
  var message = {
    messageType: MessageType.SyncRequest,
    styles: styles
  };
  iframeWindow.postMessage(message, iframeUrl);
  setTimeout(function () {
    if (shouldUpdate) {
      // HACK: In rare scenarios (specifically mobile user agent safari) the payment form iframe will not be ready to receive
      // the initial message, if the payment form iframe does not receive the message there is no response message and the timeout
      // would get called and fail the form load. We are going to resend the message to the payment form iframe if the timeout is hit,
      // this will give the payment form iframe some extra time to load and be ready to receive the message and respond properly.
      // In the rare case that the second message is not received or responded to, we will timeout and fail the payment form load.
      // This code will be replaced and refactored in the future tech debt PBI # 1291197
      iframeWindow.postMessage(message, iframeUrl);
      setTimeout(function () {
        if (shouldUpdate) {
          setStatus(PaymentFormStatus.Failed);
          // Log the failure to load the payment form
          // This is useful for debugging issues with the payment form loading
          sendFailureLog(iframeWindow, iframeUrl, new Error('Failed to load payment form, pending sync'));
        }
      }, 200);
    }
  }, 750);
  return function () {
    shouldUpdate = false;
    window.removeEventListener('message', onMessage);
  };
};
var loadedEffect = function loadedEffect(status, iframeWindow, iframeUrl, styles, setContentHeight) {
  if (status !== PaymentFormStatus.Loaded || iframeWindow === undefined || iframeUrl === undefined) {
    return;
  }
  var shouldUpdate = true;
  var message = {
    messageType: MessageType.SetStyles,
    styles: styles
  };
  iframeWindow.postMessage(message, iframeUrl);
  var onMessage = function onMessage(event) {
    if (shouldUpdate && isApplicableMessage(event, iframeUrl, MessageType.UpdateContentHeight)) {
      setContentHeight(event.data.height);
    }
  };
  window.addEventListener('message', onMessage);
  return function () {
    shouldUpdate = false;
    window.removeEventListener('message', onMessage);
  };
};
var PaymentForm = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var title = _ref.title,
    supportedMethods = _ref.supportedMethods,
    defaultSelectedSupportedMethod = _ref.defaultSelectedSupportedMethod,
    serviceCollection = _ref.serviceCollection,
    containerStyle = _ref.containerStyle,
    contentStyles = _ref.contentStyles,
    children = _ref.children,
    setNewCardAsDefault = _ref.setNewCardAsDefault;
  var _useState = useState({
      status: PaymentFormStatus.Initializing
    }),
    context = _useState[0],
    setContext = _useState[1];
  var setStatus = useCallback(function (status) {
    if (status === context.status) {
      return;
    }
    var newContext = _extends({}, context);
    newContext.status = status;
    setContext(newContext);
  }, [context]);
  var isAlreadyTokenizing = false;
  var _useState2 = useState(0),
    contentHeight = _useState2[0],
    setContentHeight = _useState2[1];
  var _useState3 = useState(),
    url = _useState3[0],
    setUrl = _useState3[1];
  var _useState4 = useState(),
    iframeWindow = _useState4[0],
    setIframeWindow = _useState4[1];
  var _useState5 = useState(defaultSelectedSupportedMethod),
    selectedSupportedMethod = _useState5[0];
  var iframeRef = createRef();
  var iframeOrigin = (url == null ? void 0 : url.replace(/\/\?.*/, '')) || '';
  useEffect(function () {
    return initializingEffect(context.status, serviceCollection, supportedMethods, selectedSupportedMethod, setUrl, setStatus);
  }, [context.status, serviceCollection, supportedMethods, selectedSupportedMethod, setStatus]);
  useEffect(function () {
    return loadingEffect(context.status, iframeRef, setStatus, setIframeWindow);
  }, [context.status, iframeRef, setStatus]);
  useEffect(function () {
    return pendingSyncEffect(context.status, iframeWindow, iframeOrigin, contentStyles, setStatus);
  }, [context.status, iframeWindow, iframeOrigin, contentStyles, setStatus]);
  useEffect(function () {
    return loadedEffect(context.status, iframeWindow, iframeOrigin, contentStyles, setContentHeight);
  }, [context.status, iframeWindow, iframeOrigin, contentStyles, setContentHeight]);
  useImperativeHandle(ref, function () {
    return {
      tokenizePaymentMethod: tokenizePaymentMethod(serviceCollection, setNewCardAsDefault, isAlreadyTokenizing, iframeWindow, iframeOrigin),
      clearForm: function clearForm$1() {
        return clearForm(iframeWindow, iframeOrigin);
      }
    };
  }, [iframeWindow, iframeOrigin, serviceCollection, setNewCardAsDefault, isAlreadyTokenizing]);
  var localStyle = _extends({}, containerStyle);
  if (context.status !== PaymentFormStatus.Loaded) {
    localStyle.display = 'none';
  }
  if (contentHeight > 0) {
    localStyle.minHeight = contentHeight;
  }
  return React.createElement(PaymentFormContext.Provider, {
    value: context
  }, React.createElement("form", {
    "aria-label": "Payment form"
  }, React.createElement(SecureFrame, {
    title: title,
    containerStyle: localStyle,
    url: url,
    ref: iframeRef
  })), children);
});

var isContentStatus = function isContentStatus(contentStatuses, currentStatus) {
  return contentStatuses.includes(currentStatus);
};
var PaymentFormContentContainer = function PaymentFormContentContainer(_ref) {
  var contentStatuses = _ref.contentStatuses,
    children = _ref.children;
  var context = useContext(PaymentFormContext);
  return isContentStatus(contentStatuses, context.status) ? React.createElement(React.Fragment, null, children) : React.createElement(React.Fragment, null);
};

var contentStatuses = [PaymentFormStatus.Failed];
var PaymentFormLoadingFailedContentContainer = function PaymentFormLoadingFailedContentContainer(_ref) {
  var children = _ref.children;
  return React.createElement(PaymentFormContentContainer, {
    contentStatuses: contentStatuses
  }, children);
};

var DefaultFailedAlert = function DefaultFailedAlert() {
  return React.createElement(PaymentFormLoadingFailedContentContainer, null, React.createElement("div", null, React.createElement("p", null, "Failed to load payment form")));
};

var contentStatuses$1 = [PaymentFormStatus.Initializing, PaymentFormStatus.Loading, PaymentFormStatus.PendingSync];
var PaymentFormLoadingContentContainer = function PaymentFormLoadingContentContainer(_ref) {
  var children = _ref.children;
  return React.createElement(PaymentFormContentContainer, {
    contentStatuses: contentStatuses$1
  }, children);
};

var DefaultLoadingAlert = function DefaultLoadingAlert() {
  return React.createElement(PaymentFormLoadingContentContainer, null, React.createElement("div", null, React.createElement("p", null, "Loading...")));
};

var TokenizationService = /*#__PURE__*/function () {
  function TokenizationService(applicationService) {
    this.defaultResult = {
      isSuccessful: false,
      completedTokenizationAttempt: false,
      suggestVerifyInformation: false,
      isRewardsCard: false,
      tokenId: null,
      displayName: null,
      mask: null,
      type: null,
      potentialDuplicate: false
    };
    this.getOrigin = function () {
      var referrer = document.referrer;
      if (!referrer) {
        return window.parent.origin;
      }
      return new URL(document.referrer).origin;
    };
    this._applicationService = applicationService;
  }
  var _proto = TokenizationService.prototype;
  _proto.tokenizeAch = /*#__PURE__*/function () {
    var _tokenizeAch = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(setAsDefault, iframeRef, iframeUrl) {
      var _iframeRef$current,
        _this = this;
      var origin, token, attemptTokenMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            origin = this.getOrigin();
            if (!(!origin || !(iframeRef != null && (_iframeRef$current = iframeRef.current) != null && _iframeRef$current.contentWindow))) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", Promise.resolve(this.defaultResult));
          case 3:
            _context.next = 5;
            return this.getTokenMachineToken(setAsDefault);
          case 5:
            token = _context.sent;
            attemptTokenMessage = {
              messageType: MessageType.GenerateTokenizeCardTokenResponse,
              token: token
            };
            return _context.abrupt("return", new Promise(function (resolve) {
              var _iframeRef$current2;
              var onMessage = function onMessage(event) {
                if (event.data.messageType !== MessageType.TokenizePaymentMethodResponse) {
                  return;
                }
                var data = event.data;
                if (!data.resultToken || !data.isInputValid) {
                  resolve(_this.defaultResult);
                  return;
                }
                window.removeEventListener('message', onMessage);
                _this._applicationService.validateTokenizeCardResultToken(data.resultToken).then(function (responseToken) {
                  resolve(responseToken);
                });
              };
              window.addEventListener('message', onMessage);
              iframeRef == null || (_iframeRef$current2 = iframeRef.current) == null || (_iframeRef$current2 = _iframeRef$current2.contentWindow) == null || _iframeRef$current2.postMessage(attemptTokenMessage, iframeUrl);
              // set the timeout for tokenization requests to return a value
              setTimeout(function () {
                window.removeEventListener('message', onMessage);
                resolve(_this.defaultResult);
              }, 30000);
            }));
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function tokenizeAch(_x, _x2, _x3) {
      return _tokenizeAch.apply(this, arguments);
    }
    return tokenizeAch;
  }();
  _proto.getTokenMachineToken = /*#__PURE__*/function () {
    var _getTokenMachineToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(setAsDefault) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this._applicationService.generateTokenizeCardToken(setAsDefault, function () {}).then(function (token) {
              return token;
            });
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getTokenMachineToken(_x4) {
      return _getTokenMachineToken.apply(this, arguments);
    }
    return getTokenMachineToken;
  }();
  _proto.validateForm = /*#__PURE__*/function () {
    var _validateForm = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(iframeRef, iframeUrl) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve) {
              var _iframeRef$current3;
              var onValidationMessage = function onValidationMessage(event) {
                if (event.data.messageType !== MessageType.IsFormValid) {
                  return;
                }
                var result = event.data;
                resolve(result.isValid);
                window.removeEventListener('message', onValidationMessage);
              };
              var requestMessage = {
                messageType: MessageType.IsFormValid,
                isValid: true
              };
              iframeRef == null || (_iframeRef$current3 = iframeRef.current) == null || (_iframeRef$current3 = _iframeRef$current3.contentWindow) == null || _iframeRef$current3.postMessage(requestMessage, iframeUrl);
              window.addEventListener('message', onValidationMessage);
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function validateForm(_x5, _x6) {
      return _validateForm.apply(this, arguments);
    }
    return validateForm;
  }();
  return TokenizationService;
}();

var ServiceCollection = /*#__PURE__*/function () {
  function ServiceCollection(tokenizer, application) {
    this._tokenizer = tokenizer;
    this._application = application;
    this._tokenizationService = new TokenizationService(application);
  }
  var _proto = ServiceCollection.prototype;
  _proto.generateRenderFormUrl = /*#__PURE__*/function () {
    var _generateRenderFormUrl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(supportedMethods, selectedSupportedMethod) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this._tokenizer.generateRenderFormUrl(this._application, supportedMethods, selectedSupportedMethod);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function generateRenderFormUrl(_x, _x2) {
      return _generateRenderFormUrl.apply(this, arguments);
    }
    return generateRenderFormUrl;
  }();
  _proto.generateRenderAchFormUrl = /*#__PURE__*/function () {
    var _generateRenderAchFormUrl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this._tokenizer.generateRenderAchFormUrl(this._application);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function generateRenderAchFormUrl() {
      return _generateRenderAchFormUrl.apply(this, arguments);
    }
    return generateRenderAchFormUrl;
  }();
  _proto.tokenizeAch = /*#__PURE__*/function () {
    var _tokenizeAch = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(setAsDefault, iframeRef, iframeUrl) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this._tokenizationService.tokenizeAch(setAsDefault, iframeRef, iframeUrl);
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function tokenizeAch(_x3, _x4, _x5) {
      return _tokenizeAch.apply(this, arguments);
    }
    return tokenizeAch;
  }();
  _proto.validateForm = /*#__PURE__*/function () {
    var _validateForm = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(iframeRef, iframeUrl) {
      var isValid;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this._tokenizationService.validateForm(iframeRef, iframeUrl);
          case 2:
            isValid = _context4.sent;
            return _context4.abrupt("return", {
              isValid: isValid,
              defaultResult: this._tokenizationService.defaultResult
            });
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function validateForm(_x6, _x7) {
      return _validateForm.apply(this, arguments);
    }
    return validateForm;
  }();
  return _createClass(ServiceCollection, [{
    key: "application",
    get: function get() {
      return this._application;
    }
  }]);
}();

var PaymentMethod;
(function (PaymentMethod) {
  PaymentMethod["BasicCard"] = "basic-card";
  PaymentMethod["SavedCard"] = "saved-card";
  PaymentMethod["BlueTarp"] = "bluetarp";
  PaymentMethod["ApplePay"] = "apple-pay";
  PaymentMethod["GooglePay"] = "google-pay";
  PaymentMethod["CreditKey"] = "credit-key";
})(PaymentMethod || (PaymentMethod = {}));

var TokenizerService = /*#__PURE__*/function () {
  function TokenizerService(domain) {
    this._domain = domain;
  }
  var _proto = TokenizerService.prototype;
  _proto.generateRenderFormUrl = /*#__PURE__*/function () {
    var _generateRenderFormUrl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(applicationService, supportedMethods, selectedSupportedMethod) {
      var token;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return applicationService.generateRenderFormToken(supportedMethods, selectedSupportedMethod);
          case 2:
            token = _context.sent;
            return _context.abrupt("return", this._domain + "/?token=" + token);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function generateRenderFormUrl(_x, _x2, _x3) {
      return _generateRenderFormUrl.apply(this, arguments);
    }
    return generateRenderFormUrl;
  }();
  _proto.generateRenderAchFormUrl = /*#__PURE__*/function () {
    var _generateRenderAchFormUrl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(applicationService) {
      var token;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return applicationService.generateRenderFormToken([PaymentMethod.BasicCard], PaymentMethod.BasicCard);
          case 2:
            token = _context2.sent;
            return _context2.abrupt("return", this._domain + "/ach?token=" + token);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function generateRenderAchFormUrl(_x4) {
      return _generateRenderAchFormUrl.apply(this, arguments);
    }
    return generateRenderAchFormUrl;
  }();
  return TokenizerService;
}();

var TokenType;
(function (TokenType) {
  TokenType[TokenType["RenderForm"] = 0] = "RenderForm";
  TokenType[TokenType["TokenizeCard"] = 1] = "TokenizeCard";
})(TokenType || (TokenType = {}));

var ApplicationService = /*#__PURE__*/function () {
  function ApplicationService(renderFormUrl, tokenizeCardUrl, validateResultUrl) {
    this._renderFormUrl = renderFormUrl;
    this._tokenizeCardUrl = tokenizeCardUrl;
    this._validateResultUrl = validateResultUrl;
  }
  var _proto = ApplicationService.prototype;
  _proto.generateTokenUrl = function generateTokenUrl(tokenType) {
    switch (tokenType) {
      case TokenType.RenderForm:
        return this._renderFormUrl;
      case TokenType.TokenizeCard:
        return this._tokenizeCardUrl;
    }
  };
  _proto.generateToken = /*#__PURE__*/function () {
    var _generateToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tokenType, body) {
      var headers, response, token;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers();
            headers.set('content-type', 'application/json');
            _context.next = 4;
            return fetch(this.generateTokenUrl(tokenType), {
              method: 'POST',
              body: JSON.stringify(body),
              headers: headers,
              credentials: 'include'
            });
          case 4:
            response = _context.sent;
            _context.t0 = response.status;
            _context.next = _context.t0 === 200 ? 8 : 14;
            break;
          case 8:
            _context.next = 10;
            return response.json();
          case 10:
            token = _context.sent;
            if (!(token.value === undefined)) {
              _context.next = 13;
              break;
            }
            throw new Error('Failed to generate token');
          case 13:
            return _context.abrupt("return", token);
          case 14:
            throw new Error('Failed to generate token');
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function generateToken(_x, _x2) {
      return _generateToken.apply(this, arguments);
    }
    return generateToken;
  }();
  _proto.generateRenderFormToken = /*#__PURE__*/function () {
    var _generateRenderFormToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(supportedMethods, selectedSupportedMethod) {
      var token;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.generateToken(TokenType.RenderForm, {
              supportedMethods: supportedMethods.map(function (paymentMethod) {
                return paymentMethod.toString().replace(/-/g, '');
              }),
              selectedSupportedMethod: selectedSupportedMethod.toString().replace(/-/g, '')
            });
          case 2:
            token = _context2.sent;
            return _context2.abrupt("return", token.value);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function generateRenderFormToken(_x3, _x4) {
      return _generateRenderFormToken.apply(this, arguments);
    }
    return generateRenderFormToken;
  }();
  _proto.generateTokenizeCardToken = /*#__PURE__*/function () {
    var _generateTokenizeCardToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(setAsDefault, callback) {
      var data, token;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            data = {
              setAsDefault: setAsDefault
            };
            callback(data);
            _context3.next = 4;
            return this.generateToken(TokenType.TokenizeCard, data);
          case 4:
            token = _context3.sent;
            return _context3.abrupt("return", token);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function generateTokenizeCardToken(_x5, _x6) {
      return _generateTokenizeCardToken.apply(this, arguments);
    }
    return generateTokenizeCardToken;
  }();
  _proto.validateTokenizeCardResultToken = /*#__PURE__*/function () {
    var _validateTokenizeCardResultToken = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(token) {
      var headers, url, response, result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            headers = new Headers();
            headers.set('content-type', 'application/json');
            url = this._validateResultUrl;
            _context4.next = 5;
            return fetch(url, {
              method: 'POST',
              body: JSON.stringify({
                token: token
              }),
              headers: headers,
              credentials: 'include'
            });
          case 5:
            response = _context4.sent;
            result = {
              isSuccessful: false,
              completedTokenizationAttempt: false,
              suggestVerifyInformation: false,
              isRewardsCard: false,
              tokenId: null,
              displayName: null,
              mask: null,
              type: null,
              potentialDuplicate: false
            };
            if (!(response.status === 200)) {
              _context4.next = 12;
              break;
            }
            _context4.next = 10;
            return response.json();
          case 10:
            result = _context4.sent;
            result.completedTokenizationAttempt = true;
          case 12:
            return _context4.abrupt("return", result);
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function validateTokenizeCardResultToken(_x7) {
      return _validateTokenizeCardResultToken.apply(this, arguments);
    }
    return validateTokenizeCardResultToken;
  }();
  return ApplicationService;
}();

var AuthorizeCreditKeyResult = function AuthorizeCreditKeyResult(statusCode, responseBody) {
  this.statusCode = statusCode;
  this.isSuccessful = statusCode === 200;
  this.responseBody = responseBody;
  if (this.isSuccessful) {
    this.creditKeyApplicationUrl = JSON.parse(responseBody).creditKeyApplicationUrl;
  } else {
    this.creditKeyApplicationUrl = null;
  }
};

var PaymentMethodType;
(function (PaymentMethodType) {
  PaymentMethodType["AmericanExpress"] = "AmericanExpress";
  PaymentMethodType["Visa"] = "Visa";
  PaymentMethodType["Mastercard"] = "Mastercard";
  PaymentMethodType["Discover"] = "Discover";
  PaymentMethodType["BlueTarp"] = "Bluetarp";
  PaymentMethodType["ApplePay"] = "ApplePay";
  PaymentMethodType["GooglePay"] = "GooglePay";
  PaymentMethodType["CreditKey"] = "CreditKey";
  PaymentMethodType["ACH"] = "ACH";
})(PaymentMethodType || (PaymentMethodType = {}));

var PaymentMethodResult = function PaymentMethodResult(statusCode, responseBody) {
  this.statusCode = statusCode;
  this.isSuccessful = statusCode === 200;
  this.responseBody = responseBody;
  if (this.isSuccessful) {
    this.paymentMethods = JSON.parse(responseBody).paymentMethods;
  } else {
    this.paymentMethods = new Array();
  }
  this.isCreditKeyEnabled = this.paymentMethods.some(function (e) {
    return e.paymentMethodType === PaymentMethodType.CreditKey;
  });
};

var PaymentService = /*#__PURE__*/function () {
  function PaymentService(domain) {
    this._domain = domain;
  }
  var _proto = PaymentService.prototype;
  _proto.sendSignedRequest = /*#__PURE__*/function () {
    var _sendSignedRequest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, path) {
      var headers, url, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers();
            headers.set('Content-Type', 'application/json');
            headers.set('Clark-Division', request.division);
            headers.set('Authorization', 'Serial ' + request.serialNumber);
            headers.set('Clark-Content-Signature', request.signature);
            headers.set('Clark-Content-Date', request.timestamp);
            url = "" + this._domain + path;
            _context.next = 9;
            return fetch(url, {
              method: 'POST',
              body: request.requestBody,
              headers: headers,
              credentials: 'omit'
            });
          case 9:
            response = _context.sent;
            return _context.abrupt("return", response);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function sendSignedRequest(_x, _x2) {
      return _sendSignedRequest.apply(this, arguments);
    }
    return sendSignedRequest;
  }();
  _proto.getAvailablePaymentMethods = /*#__PURE__*/function () {
    var _getAvailablePaymentMethods = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.sendSignedRequest(request, '/v2/Customer/getavailablepaymentmethods');
          case 2:
            response = _context2.sent;
            _context2.t0 = response.status;
            _context2.next = _context2.t0 === 200 ? 6 : 12;
            break;
          case 6:
            _context2.t1 = PaymentMethodResult;
            _context2.t2 = response.status;
            _context2.next = 10;
            return response.text();
          case 10:
            _context2.t3 = _context2.sent;
            return _context2.abrupt("return", new _context2.t1(_context2.t2, _context2.t3));
          case 12:
            return _context2.abrupt("return", new PaymentMethodResult(response.status, response.statusText));
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function getAvailablePaymentMethods(_x3) {
      return _getAvailablePaymentMethods.apply(this, arguments);
    }
    return getAvailablePaymentMethods;
  }();
  _proto.authorizeCreditKeyPayment = /*#__PURE__*/function () {
    var _authorizeCreditKeyPayment = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(request) {
      var response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.sendSignedRequest(request, '/v2/order/authorize/creditkey');
          case 2:
            response = _context3.sent;
            _context3.t0 = response.status;
            _context3.next = _context3.t0 === 200 ? 6 : 12;
            break;
          case 6:
            _context3.t1 = AuthorizeCreditKeyResult;
            _context3.t2 = response.status;
            _context3.next = 10;
            return response.text();
          case 10:
            _context3.t3 = _context3.sent;
            return _context3.abrupt("return", new _context3.t1(_context3.t2, _context3.t3));
          case 12:
            return _context3.abrupt("return", new AuthorizeCreditKeyResult(response.status, response.statusText));
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function authorizeCreditKeyPayment(_x4) {
      return _authorizeCreditKeyPayment.apply(this, arguments);
    }
    return authorizeCreditKeyPayment;
  }();
  return PaymentService;
}();

var generateEmptyBasicStyles = function generateEmptyBasicStyles() {
  var styles = {
    container: {
      style: {},
      cardNumberContainer: {
        style: {},
        iconContainer: {
          style: {},
          visa: {
            style: {}
          },
          discover: {
            style: {}
          },
          americanExpress: {
            style: {}
          },
          mastercard: {
            style: {}
          }
        },
        inputContainer: {
          defaultStyle: {},
          errorStyle: {},
          input: {
            defaultStyle: {},
            errorStyle: {}
          },
          label: {
            defaultStyle: {},
            errorStyle: {}
          }
        },
        error: {
          style: {}
        }
      },
      verificationDetailsContainer: {
        style: {},
        expiryYearContainer: {
          style: {},
          inputContainer: {
            defaultStyle: {},
            errorStyle: {},
            input: {
              defaultStyle: {},
              errorStyle: {}
            },
            label: {
              defaultStyle: {},
              errorStyle: {}
            },
            icon: {
              defaultStyle: {},
              errorStyle: {}
            }
          },
          error: {
            style: {}
          }
        },
        expiryMonthContainer: {
          style: {},
          inputContainer: {
            defaultStyle: {},
            errorStyle: {},
            input: {
              defaultStyle: {},
              errorStyle: {}
            },
            label: {
              defaultStyle: {},
              errorStyle: {}
            },
            icon: {
              defaultStyle: {},
              errorStyle: {}
            }
          },
          error: {
            style: {}
          }
        },
        cardSecurityCodeContainer: {
          style: {},
          inputContainer: {
            defaultStyle: {},
            errorStyle: {},
            input: {
              defaultStyle: {},
              errorStyle: {}
            },
            label: {
              defaultStyle: {},
              errorStyle: {}
            },
            tipIcon: {
              defaultStyle: {},
              errorStyle: {}
            }
          },
          error: {
            style: {}
          }
        }
      }
    }
  };
  return styles;
};

var generateEmptyRenderFormStyles = function generateEmptyRenderFormStyles() {
  var styles = {
    basicCard: generateEmptyBasicStyles()
  };
  return styles;
};

var SignedRequest = function SignedRequest(timestamp, requestBody, signature, division, serialNumber) {
  this.timestamp = timestamp;
  this.requestBody = requestBody;
  this.signature = signature;
  this.division = division;
  this.serialNumber = serialNumber;
};

var State;
(function (State) {
  State[State["LoadingSecureForm"] = 0] = "LoadingSecureForm";
  State[State["Tokenizing"] = 1] = "Tokenizing";
  State[State["Loaded"] = 2] = "Loaded";
  State[State["Error"] = 3] = "Error";
})(State || (State = {}));
var PaymentContext = /*#__PURE__*/React.createContext({
  state: State.LoadingSecureForm,
  paymentServerFrameWindow: null,
  authorizePromise: undefined,
  authorizePayment: function authorizePayment() {
    return new Promise(function (resolve) {
      var defaultAuthorizeResult = {
        isInputValid: false,
        completedAuthorizeRequest: false,
        authorizeRequestId: undefined
      };
      resolve(defaultAuthorizeResult);
    });
  },
  setState: function setState() {},
  setPaymentServerFrameWindow: function setPaymentServerFrameWindow() {},
  logError: function logError() {}
});
var PaymentProvider = function PaymentProvider(props) {
  var _useState = useState({
      state: State.LoadingSecureForm,
      paymentServerFrameWindow: null,
      authorizePromise: undefined
    }),
    paymentFormState = _useState[0],
    setPaymentFormState = _useState[1];
  var defaultOnError = function defaultOnError(type, event) {
    console.debug("Error: " + type);
    console.debug(event);
  };
  var authorizePayment = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signedData, timeoutInMilliseconds) {
      var validStates, tokenizeMessage, authorizePromise, response, defaultAuthorizeResult;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validStates = [State.Loaded, State.Tokenizing];
            if (validStates.includes(paymentFormState.state)) {
              _context.next = 5;
              break;
            }
            logError('AuthorizePaymentNotReady', {
              message: 'Authorize called while not in Loaded or Tokenizing state',
              context: paymentFormState
            });
            _context.next = 24;
            break;
          case 5:
            if (!(paymentFormState.paymentServerFrameWindow === null)) {
              _context.next = 9;
              break;
            }
            logError('AuthorizePaymentNotReady', {
              message: 'Payment Iframe not set',
              context: paymentFormState
            });
            _context.next = 24;
            break;
          case 9:
            tokenizeMessage = {
              messageType: MessageType.AuthorizePaymentMethodRequest,
              signedData: signedData
            };
            authorizePromise = paymentFormState.authorizePromise || paymentFormState.paymentServerFrameWindow.sendMessage(MessageType.AuthorizePaymentMethodResponse, tokenizeMessage, timeoutInMilliseconds);
            setPaymentFormState(_extends({}, paymentFormState, {
              state: State.Tokenizing,
              authorizePromise: authorizePromise
            }));
            _context.prev = 12;
            _context.next = 15;
            return authorizePromise;
          case 15:
            response = _context.sent;
            defaultAuthorizeResult = {
              isInputValid: response.isInputValid,
              completedAuthorizeRequest: response.completedAuthorizeRequest,
              authorizeRequestId: response.authorizeRequestId
            };
            setPaymentFormState(function (currentState) {
              return _extends({}, currentState, {
                state: State.Loaded,
                authorizePromise: undefined
              });
            });
            return _context.abrupt("return", defaultAuthorizeResult);
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](12);
            logError('AuthorizePaymentException', {
              message: 'An unexpected exception was thrown during authorization',
              context: _context.t0
            });
          case 24:
            return _context.abrupt("return", {
              isInputValid: false,
              completedAuthorizeRequest: false,
              authorizeRequestId: undefined
            });
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[12, 21]]);
    }));
    return function authorizePayment(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var logError = function logError(type, event) {
    var _props$onError;
    ((_props$onError = props.onError) != null ? _props$onError : defaultOnError)(type, event);
    if (paymentFormState.state === State.LoadingSecureForm) {
      setPaymentFormState(_extends({}, paymentFormState, {
        state: State.Error
      }));
    }
  };
  var paymentFormContext = _extends({}, paymentFormState, {
    setState: function setState(state) {
      return setPaymentFormState(_extends({}, paymentFormState, {
        state: state
      }));
    },
    authorizePayment: authorizePayment,
    setPaymentServerFrameWindow: function setPaymentServerFrameWindow(paymentServerFrameWindow) {
      return setPaymentFormState(_extends({}, paymentFormState, {
        paymentServerFrameWindow: paymentServerFrameWindow,
        state: State.Loaded
      }));
    },
    logError: logError
  });
  return React.createElement(PaymentContext.Provider, {
    value: paymentFormContext
  }, props.children);
};

function sendMessage(responseMessageType, message, timeoutInMilliseconds) {
  var iframeWindow = this;
  return new Promise(function (resolve, reject) {
    var onMessageReceived = function onMessageReceived(event) {
      clearTimeout(timeout);
      if (event.data.messageType === responseMessageType) {
        resolve(event.data);
      }
    };
    var timeout = setTimeout(function () {
      window.removeEventListener('message', onMessageReceived);
      reject("Timed out after " + timeoutInMilliseconds + " milliseconds");
    }, timeoutInMilliseconds);
    window.addEventListener('message', onMessageReceived);
    iframeWindow.window.postMessage(message, iframeWindow.origin);
  });
}
var convertWindowToCommunciationWindow = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(iframeWindow, styles, origin) {
    var paymentServerFrameWindow, syncMessage, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paymentServerFrameWindow = {
            window: iframeWindow,
            communicationSourceId: Date.now().toString(),
            communicationTargetId: undefined,
            sendMessage: sendMessage,
            origin: origin != null ? origin : ''
          };
          syncMessage = {
            messageType: MessageType.SyncRequest,
            styles: styles,
            sourceWindowId: paymentServerFrameWindow.communicationSourceId
          };
          _context.next = 4;
          return paymentServerFrameWindow.sendMessage(MessageType.SyncResponse, syncMessage, 3000);
        case 4:
          response = _context.sent;
          paymentServerFrameWindow.communicationTargetId = response.targetWindowId;
          return _context.abrupt("return", paymentServerFrameWindow);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function convertWindowToCommunciationWindow(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var PaymentServerFrame = function PaymentServerFrame(_ref) {
  var title = _ref.title,
    containerStyles = _ref.containerStyles,
    formStyles = _ref.formStyles,
    url = _ref.url,
    hideIframe = _ref.hideIframe;
  var _useContext = useContext(PaymentContext),
    setPaymentServerFrameWindow = _useContext.setPaymentServerFrameWindow,
    logError = _useContext.logError;
  var _useState = useState(null),
    contentHeight = _useState[0],
    setContentHeight = _useState[1];
  var onLoad = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var paymentServerFrameWindow;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(event.currentTarget.contentWindow !== null)) {
              _context.next = 13;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return convertWindowToCommunciationWindow(event.currentTarget.contentWindow, formStyles || generateEmptyRenderFormStyles(), event.currentTarget.getAttribute('src'));
          case 4:
            paymentServerFrameWindow = _context.sent;
            setPaymentServerFrameWindow(paymentServerFrameWindow);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            logError('PaymentServerFrameSyncException', {
              message: 'An unexpected exception was thrown while trying to sync the Payment Iframe',
              context: _context.t0
            });
          case 11:
            _context.next = 14;
            break;
          case 13:
            logError('PaymentServerFrameOnLoadException', {
              message: 'On load called without a content window',
              context: event
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function onLoad(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var listenForContentHeightEffect = function listenForContentHeightEffect(setContentHeight) {
    var onMessage = function onMessage(event) {
      if (event.data.messageType === MessageType.UpdateContentHeight) {
        setContentHeight(event.data.height);
      }
    };
    window.addEventListener('message', onMessage);
    return function () {
      window.removeEventListener('message', onMessage);
    };
  };
  useEffect(function () {
    return listenForContentHeightEffect(setContentHeight);
  }, [setContentHeight]);
  var onError = function onError(event) {
    logError('PaymentServerFrameOnError', {
      message: 'An unexpected exception was thrown by the Payment Iframe',
      context: event
    });
  };
  var updatedStyles = containerStyles ? _extends({}, containerStyles) : {};
  updatedStyles.height = contentHeight || updatedStyles.height;
  if (hideIframe) {
    updatedStyles.display = 'none';
  }
  return React.createElement("iframe", {
    title: title,
    src: url,
    style: updatedStyles,
    onLoad: onLoad,
    onError: onError
  });
};
var BasicCardForm = function BasicCardForm(_ref3) {
  var title = _ref3.title,
    containerStyles = _ref3.containerStyles,
    paymentServerDomain = _ref3.paymentServerDomain,
    hideIframe = _ref3.hideIframe;
  return React.createElement(PaymentServerFrame, {
    title: title,
    containerStyles: containerStyles,
    url: "https://" + paymentServerDomain + "/form",
    hideIframe: hideIframe
  });
};

var ApplePayService = /*#__PURE__*/function () {
  function ApplePayService(configuration) {
    this._configuration = configuration;
  }
  var _proto = ApplePayService.prototype;
  _proto.createApplePaySession = /*#__PURE__*/function () {
    var _createApplePaySession = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(validationUrl, origin) {
      var requestData, response, json;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requestData = {
              validationUrl: validationUrl,
              initiativeContext: origin
            };
            _context.next = 3;
            return fetch(this._configuration.tokenizerDomain + "/ApplePay/session/", {
              method: 'POST',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
                'Clark-Division': this._configuration.divisionName
              },
              body: JSON.stringify(requestData)
            });
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            json = _context.sent;
            return _context.abrupt("return", json);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function createApplePaySession(_x, _x2) {
      return _createApplePaySession.apply(this, arguments);
    }
    return createApplePaySession;
  }();
  _proto.generateCheckoutSession = /*#__PURE__*/function () {
    var _generateCheckoutSession = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", this._configuration.generateCheckoutContext());
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function generateCheckoutSession() {
      return _generateCheckoutSession.apply(this, arguments);
    }
    return generateCheckoutSession;
  }();
  _proto.checkout = /*#__PURE__*/function () {
    var _checkout = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(token, payment) {
      var response, json;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetch(this._configuration.tokenizerDomain + "/ApplePay/checkout", {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token.value
              },
              body: JSON.stringify({
                token: payment.token
              })
            });
          case 2:
            response = _context3.sent;
            _context3.next = 5;
            return response.json();
          case 5:
            json = _context3.sent;
            return _context3.abrupt("return", json);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function checkout(_x3, _x4) {
      return _checkout.apply(this, arguments);
    }
    return checkout;
  }();
  _proto.getTransactionTotal = function getTransactionTotal(paymentDisplay) {
    return {
      label: paymentDisplay.label,
      amount: paymentDisplay.total.toString()
    };
  };
  _proto.getTransactionCharges = function getTransactionCharges(paymentDisplay) {
    var charges = [];
    this.pushCharge(charges, 'Subtotal', paymentDisplay.subtotal);
    this.pushCharge(charges, 'Tax', paymentDisplay.tax);
    this.pushCharge(charges, 'Shipping', paymentDisplay.shipping);
    this.pushCharge(charges, 'Duty', paymentDisplay.duty);
    this.pushCharge(charges, 'Discount', paymentDisplay.discount, true);
    this.pushCharge(charges, 'Store Credit', paymentDisplay.storeCredit, true);
    return charges;
  };
  _proto.pushCharge = function pushCharge(charges, name, amount, showNegative) {
    if (showNegative === void 0) {
      showNegative = false;
    }
    if (amount === 0) {
      return;
    }
    charges.push({
      label: name,
      amount: showNegative ? "-" + amount.toString() : amount.toString()
    });
  };
  return ApplePayService;
}();

function IsApplePayAvailableEffect(setIsApplePayAvailable) {
  useEffect(function () {
    var script = loadSrcScript();
    script.onload = function () {
      if (typeof ApplePaySession === 'undefined') {
        return;
      }
      var canMakePayments = ApplePaySession.canMakePayments();
      setIsApplePayAvailable(canMakePayments);
    };
    return function () {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  });
}
function LoadApplePayJavaScriptEffect(onLoad) {
  useEffect(function () {
    var script = loadSrcScript();
    script.onload = onLoad;
    return function () {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  });
}
function ConfigureApplePayWebsiteIcon(websiteIconSrc) {
  useEffect(function () {
    var linkElement = document.createElement('link');
    linkElement.rel = 'apple-touch-icon';
    linkElement.href = websiteIconSrc;
    try {
      document.head.appendChild(linkElement);
      return function () {
        document.head.removeChild(linkElement);
      };
    } catch (error) {
      if (linkElement.parentNode === document.head) {
        document.head.removeChild(linkElement);
      }
      return function () {};
    }
  });
}
var loadSrcScript = function loadSrcScript() {
  var applePayJsSrc = 'https://applepay.cdn-apple.com/jsapi/v1.3.2/apple-pay-sdk.js';
  var script = document.createElement('script');
  script.async = true;
  script.src = applePayJsSrc;
  document.body.appendChild(script);
  return script;
};

function ApplePayButton(props) {
  var _props$styles, _props$styles2, _props$styles3, _props$styles$buttonT, _props$styles4, _props$styles$color$t, _props$styles5;
  var applePayButtonId = 'apple-pay-button';
  var setApplePayButtonClick = function setApplePayButtonClick() {
    var applePayButton = document.getElementById(applePayButtonId);
    if (applePayButton) {
      applePayButton.onclick = onApplePayButtonClicked;
    }
  };
  LoadApplePayJavaScriptEffect(setApplePayButtonClick);
  if (props.websiteIconSrc === undefined) {
    ConfigureApplePayWebsiteIcon('/');
  } else {
    ConfigureApplePayWebsiteIcon(props.websiteIconSrc);
  }
  var numberToPixels = function numberToPixels(value, defaultValue) {
    return value === undefined ? defaultValue : value + "px";
  };
  var styles = {
    '--apple-pay-button-width': (_props$styles = props.styles) == null ? void 0 : _props$styles.width,
    '--apple-pay-button-height': (_props$styles2 = props.styles) == null ? void 0 : _props$styles2.height,
    '--apple-pay-button-border-radius': numberToPixels((_props$styles3 = props.styles) == null ? void 0 : _props$styles3.borderRadiusPixels, '5px'),
    '--apple-pay-button-padding': '5px 0px'
  };
  var buttonType = (_props$styles$buttonT = (_props$styles4 = props.styles) == null || (_props$styles4 = _props$styles4.buttonType) == null ? void 0 : _props$styles4.toString()) != null ? _props$styles$buttonT : 'check-out';
  var color = (_props$styles$color$t = (_props$styles5 = props.styles) == null || (_props$styles5 = _props$styles5.color) == null ? void 0 : _props$styles5.toString()) != null ? _props$styles$color$t : 'black';
  var onApplePayButtonClicked = function onApplePayButtonClicked() {
    if (!ApplePaySession || props.enableApplePayButton && !props.enableApplePayButton()) {
      return;
    }
    var applePayService = new ApplePayService(props.configuration);
    var request = {
      countryCode: 'US',
      currencyCode: 'USD',
      merchantCapabilities: ['supports3DS'],
      supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      lineItems: applePayService.getTransactionCharges(props.paymentDisplay),
      total: applePayService.getTransactionTotal(props.paymentDisplay)
    };
    var session = new ApplePaySession(3, request);
    session.onvalidatemerchant = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var merchantSession;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return applePayService.createApplePaySession(event.validationURL, window.location.hostname);
            case 2:
              merchantSession = _context.sent;
              session.completeMerchantValidation(merchantSession);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    session.onpaymentmethodselected = function (_) {
      var update = {
        newTotal: applePayService.getTransactionTotal(props.paymentDisplay),
        newLineItems: applePayService.getTransactionCharges(props.paymentDisplay)
      };
      session.completePaymentMethodSelection(update);
    };
    session.onpaymentauthorized = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var status, checkoutSessionToken, checkoutResult, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              status = ApplePaySession.STATUS_SUCCESS;
              _context2.prev = 1;
              _context2.next = 4;
              return applePayService.generateCheckoutSession();
            case 4:
              checkoutSessionToken = _context2.sent;
              _context2.next = 7;
              return applePayService.checkout(checkoutSessionToken, event.payment);
            case 7:
              checkoutResult = _context2.sent;
              props.onCheckoutCompleted(checkoutResult);
              if (!checkoutResult.isApproved) {
                status = ApplePaySession.STATUS_FAILURE;
              }
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](1);
              status = ApplePaySession.STATUS_FAILURE;
            case 15:
              result = {
                status: status
              };
              session.completePayment(result);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 12]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    session.oncancel = function (_) {};
    session.begin();
  };
  return React.createElement("apple-pay-button", {
    id: applePayButtonId,
    style: styles,
    buttonstyle: color,
    type: buttonType,
    locale: "en-US"
  });
}

var ApplePayButtonType;
(function (ApplePayButtonType) {
  ApplePayButtonType["Checkout"] = "check-out";
  ApplePayButtonType["Continue"] = "continue";
  ApplePayButtonType["Donate"] = "donate";
  ApplePayButtonType["Order"] = "order";
  ApplePayButtonType["Pay"] = "pay";
  ApplePayButtonType["Plain"] = "plain";
  ApplePayButtonType["Subscribe"] = "subscribe";
})(ApplePayButtonType || (ApplePayButtonType = {}));

var ApplePayButtonColor;
(function (ApplePayButtonColor) {
  ApplePayButtonColor["Black"] = "black";
  ApplePayButtonColor["White"] = "white";
  ApplePayButtonColor["WhiteOutline"] = "white-outline";
})(ApplePayButtonColor || (ApplePayButtonColor = {}));

function useListenForMessageEffect(onMessage) {
  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      window.removeEventListener('message', onMessage);
    };
  }, []);
}

function useRenderFormTokenEffect(serviceCollection, loadedCallback, failedCallback) {
  useEffect(function () {
    serviceCollection.generateRenderAchFormUrl().then(function (url) {
      loadedCallback(url);
    })["catch"](function () {
      failedCallback();
    });
  }, []);
}

function useTokenizeAchEffect(isTokenizing, serviceCollection, iframeRef, iframeUrl, setAsDefault, tokenizationCallback) {
  useEffect(function () {
    if (!isTokenizing) {
      return;
    }
    serviceCollection.validateForm(iframeRef, iframeUrl).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(validationResult) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (validationResult.isValid) {
                _context.next = 3;
                break;
              }
              tokenizationCallback(validationResult.defaultResult);
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return serviceCollection.tokenizeAch(setAsDefault, iframeRef, iframeUrl);
            case 5:
              result = _context.sent;
              tokenizationCallback(result);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }, [isTokenizing, serviceCollection, tokenizationCallback]);
}

function AchForm(props) {
  var minimumHeight = 400;
  var iframeRef = useRef(null);
  var _useState = useState(true),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(false),
    failedToLoad = _useState2[0],
    setFailedToLoad = _useState2[1];
  var _useState3 = useState(minimumHeight + "px"),
    height = _useState3[0],
    setHeight = _useState3[1];
  var _useState4 = useState(''),
    iframeUrl = _useState4[0],
    setIframeUrl = _useState4[1];
  var onUpdateContentHeightMessage = function onUpdateContentHeightMessage(message) {
    if (message.data.messageType !== MessageType.UpdateContentHeight) {
      return;
    }
    var messageData = message.data;
    if (minimumHeight < messageData.height) {
      setHeight(messageData.height + "px");
    }
  };
  var onRenderLoadFailure = function onRenderLoadFailure() {
    setLoading(false);
    setFailedToLoad(true);
  };
  useRenderFormTokenEffect(props.serviceCollection, setIframeUrl, onRenderLoadFailure);
  useListenForMessageEffect(onUpdateContentHeightMessage);
  useTokenizeAchEffect(props.isTokenizing, props.serviceCollection, iframeRef, iframeUrl, props.setAsDefault, props.tokenizationCallback);
  return React.createElement("form", {
    "aria-label": "Payment form"
  }, React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, loading || failedToLoad ? React.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: 99,
      height: height,
      width: props.width,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React.createElement("h1", {
    hidden: !loading
  }, "Loading..."), React.createElement("h1", {
    hidden: !failedToLoad
  }, "There was an error loading the form.")) : React.createElement(React.Fragment, null), React.createElement("iframe", {
    style: {
      height: height,
      border: 'none',
      width: props.width
    },
    title: "Ach Payment Form",
    src: iframeUrl,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    onError: function onError() {
      setLoading(false);
      setFailedToLoad(true);
    },
    ref: iframeRef
  })));
}

export default PaymentForm;
export { AchForm, ApplePayButton, ApplePayButtonColor, ApplePayButtonType, ApplicationService, AuthorizeCreditKeyResult, BasicCardForm, DefaultFailedAlert, DefaultLoadingAlert, IsApplePayAvailableEffect, PaymentContext, State as PaymentContextState, PaymentFormContentContainer, PaymentFormContext, PaymentFormLoadingContentContainer, PaymentFormLoadingFailedContentContainer, PaymentFormStatus, PaymentMethod, PaymentMethodResult, PaymentMethodType, PaymentProvider, PaymentService, PaymentMethodType as PaymentType, ServiceCollection, SignedRequest, TokenizerService, generateEmptyRenderFormStyles };
//# sourceMappingURL=payment-client.esm.js.map
